import React from "react";
import { StyledArrow } from "./styledComponents";

export const TimeArrow = () => (
  <StyledArrow src={`${import.meta.env.VITE_ASSET_BASE_URL}/icons/Timesheets/time-arrow.svg`} />
);
